export default {"src":"/_next/static/media/ic-close.22801f8f.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};